/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Buyer_Edit_HintInputs */

const vi_einvoice_buyer_edit_hint = /** @type {(inputs: Einvoice_Buyer_Edit_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chỉnh người mua, ngày hóa đơn, tên hàng, chiết khấu và tiền VAT trên bản nháp.`)
};

/**

* @param {Einvoice_Buyer_Edit_HintInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_buyer_edit_hint = /** @type {((inputs?: Einvoice_Buyer_Edit_HintInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Buyer_Edit_HintInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_buyer_edit_hint(inputs)
});